import React from 'react';
// lightweight class join helper to avoid adding a dependency
const join = (...parts) => parts.filter(Boolean).join(' ');

const VARIANTS = {
  primary: 'bg-accent-500 text-white hover:bg-accent-600 focus:ring-accent-300',
  secondary: 'bg-primary-100 text-primary-800 hover:bg-primary-200 focus:ring-accent-300',
  ghost: 'bg-transparent text-primary-800 hover:bg-primary-50',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-300',
  icon: 'bg-white/90 text-gray-600 hover:text-accent-600 hover:bg-white shadow',
};

const SIZES = {
  sm: 'px-2 py-1 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-6 py-3 text-lg',
  icon: 'w-10 h-10',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  onClick,
  ariaLabel,
  ...rest
}) => {
  const base = 'inline-flex items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 transition-transform duration-150';
  const variantClass = VARIANTS[variant] || VARIANTS.primary;
  const sizeClass = size === 'icon' ? SIZES.icon : SIZES[size] || SIZES.md;

  return (
    <button
      type={type}
      onClick={onClick}
      aria-label={ariaLabel}
      className={join(base, variantClass, sizeClass, className)}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
